<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>Allowlist</p>
          <div class="float-right">
            <el-popover placement="bottom" title="Select Action" trigger="click" class="mr10">
              <el-tooltip content="Approve" placement="top">
                <el-button type="success" circle icon="el-icon-check" @click="approve"></el-button>
              </el-tooltip>
              <el-tooltip content="Reject" placement="top">
                <el-button type="primary" circle icon="el-icon-minus" class="ml10" @click="reject"></el-button>
              </el-tooltip>
              <el-tooltip content="Disable" placement="top">
                <el-button type="danger" circle icon="el-icon-close" class="ml10" @click="remove"></el-button>
              </el-tooltip>
              <el-button slot="reference" type="primary" icon="el-icon-position" class="ml10"
                         :disabled="['disabled-list', 'block-list'].includes(tabs)">Action</el-button>
            </el-popover>

            <DeletedRejectedFilter v-if="tabs === 'disabled-list'" />
            <Filters v-else/>
            <el-tooltip :content="insertText" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
                class="ml10"
                :disabled="!['allow-list', 'block-list'].includes(tabs)"
              ></el-button>
            </el-tooltip>
          </div>
        </div>
        <el-tabs type="border-card"  @tab-click="tabClick" v-model="tabs">
          <el-tab-pane label="Allowlist" name="allow-list">
            <Table />
            <Dialog />
            <DialogEdit />
          </el-tab-pane>
          <el-tab-pane label="Pending Requests" name="pending-list">
            <PendingTable />
            <ReviewDialog />
          </el-tab-pane>
          <el-tab-pane label="Deleted and Rejected" name="disabled-list">
            <DisabledTable />
            <ReviewDisabledDialog />
          </el-tab-pane>
          <el-tab-pane label="Blocklist" name="block-list">
            <BlocklistTable />
            <BlocklistDialog />
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '../components/youtube/whitelist/Filters'
import DeletedRejectedFilter from "../components/youtube/whitelist/DeletedRejectedFilter";
import Table from '../components/youtube/whitelist/Table'
import DisabledTable from "@/modules/admin/cms/components/youtube/whitelist/DisabledTable.vue";
import PendingTable from "@/modules/admin/cms/components/youtube/whitelist/PendingTable.vue";
import BlocklistTable from "@/modules/admin/cms/components/youtube/whitelist/BlocklistTable.vue";
import Dialog from '../components/youtube/whitelist/Dialog'
import DialogEdit from '../components/youtube/whitelist/DialogEdit'
import BlocklistDialog from '../components/youtube/whitelist/BlocklistDialog'
import ReviewDialog from '../components/youtube/whitelist/ReviewDialog'
import ReviewDisabledDialog from '../components/youtube/whitelist/ReviewDisabledDialog'
import {mapState, mapMutations, mapActions} from 'vuex'

export default {
  components: {
    PendingTable,
    DisabledTable,
    BlocklistTable,
    BlocklistDialog,
    Filters,
    DeletedRejectedFilter,
    Table,
    Dialog,
    ReviewDialog,
    ReviewDisabledDialog,
    DialogEdit
  },
  data() {
    return {
      tabs: 'allow-list'
    }
  },

  computed: {
    ...mapState('youtubeWhitelist', ['loading', 'selectedAllChannels', 'selectedChannels']),
    insertText() {
      let text = 'Insert';

      switch (this.tabs) {
        case 'allow-list':
          text += ' into Allowlist';
          break;
        case 'block-list':
          text += ' into Blocklist';
          break;
        default:
          text += ' (not available)';
          break;
      }

      return text;
    }
  },

  methods: {
    ...mapMutations('youtubeWhitelist', [
        'setPage', 'setPageSize', 'setDialogInsert', 'setDialogBlock', 'setSelectedAllChannels', 'setSelectedChannels'
    ]),
    ...mapActions('youtubeWhitelist', ['destroy', 'rejectInsert', 'approveInsert','readPendingList','readDisabledList','readBlockList']),
    insert() {
      switch (this.tabs) {
        case 'allow-list':
          this.setDialogInsert(true)
          break
        case 'block-list':
          this.setDialogBlock(true)
          break
        default:
          break
      }
    },
    tabClick(tab){
      this.setPageSize(10)
      this.setPage(1)
      this.setSelectedAllChannels(false)
      this.setSelectedChannels([])

      if(tab.name === 'allow-list') {
        this.readWhitelist()
      }
      else if (tab.name === 'pending-list'){
        this.readPendingList()
      }
      else if (tab.name === 'disabled-list'){
        this.readDisabledList()
      }
      else if (tab.name === 'block-list')
      {
        this.readBlockList()
      }
    },

    approve() {
      this.approveInsert(this.selectedAllChannels ? [] : this.selectedChannels)
    },

    reject() {
      this.rejectInsert({ reason: null, ids: this.selectedAllChannels ? [] : this.selectedChannels })
    },

    remove() {
      this.destroy(this.selectedAllChannels ? [] : this.selectedChannels)
    }
  }
}
</script>
